import { createStep } from './rocket-configs';
import { getSetupGuide } from '@/features/setup-guide/api';

export const DESIGN_AN_EMAIL = [
  createStep({
    id: 'edit-message',
    ariaLabel: 'Edit email message',
    content: 'Edit email message',
    queryFn: getSetupGuide,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      if (data?.setup_guide.broadcasts_rocket_edited_email_at != null) {
        return 1;
      }
      return 0;
    },
    modelId: 'broadcasts_rocket_edited_email_at',
    href: (setupGuide) => {
      if (setupGuide?.sample_newsletter_id == null || setupGuide?.sample_template_id == null) {
        return `broadcasts/newsletters/`;
      }
      const url = `composer/newsletters/${setupGuide?.sample_newsletter_id}/templates/${setupGuide?.sample_template_id}`;
      return url;
    },
  }),
  createStep({
    id: 'preview-message',
    ariaLabel: 'Preview message',
    content: 'Preview message',
    queryFn: getSetupGuide,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      if (data?.setup_guide.broadcasts_rocket_previewed_email_at != null) {
        return 1;
      }
      return 0;
    },
    modelId: 'broadcasts_rocket_previewed_email_at',
    href: (setupGuide) => {
      if (setupGuide?.sample_newsletter_id == null || setupGuide?.sample_template_id == null) {
        return `broadcasts/newsletters/`;
      }
      const url = `composer/newsletters/${setupGuide?.sample_newsletter_id}/templates/${setupGuide?.sample_template_id}`;
      return url;
    },
  }),
  createStep({
    id: 'test-message',
    ariaLabel: 'Send yourself a test message',
    content: 'Send yourself a test message',
    tooltip: 'When editing an email, click Actions > Send test',
    queryFn: getSetupGuide,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      if (data?.setup_guide.broadcasts_rocket_sent_test_message_at != null) {
        return 1;
      }
      return 0;
    },
    modelId: 'broadcasts_rocket_sent_test_message_at',
    href: (setupGuide) => {
      if (setupGuide?.sample_newsletter_id == null || setupGuide?.sample_template_id == null) {
        return `broadcasts/newsletters/`;
      }
      const url = `composer/newsletters/${setupGuide?.sample_newsletter_id}/templates/${setupGuide?.sample_template_id}`;
      return url;
    },
  }),
] as const;
